import Intro from "./IntroExpert";
import IntroPlus from "./IntroExpertPlus";
import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from "react";
import './IntroTab.scss'
import { useLocation } from "react-router-dom";
import { ClientOnly, useClient } from "shared/components/ClientOnly";
import Slider from 'react-slick'
export const IntroTab = () => {
  // const isClient = useClient()
  const ref = useRef()
  const version = getVersion()
  // useLayoutEffect(() => {
  //   console.log('is cliebnt===', version)
  //   setupSlide()
  // }, [isClient])

  let slide = 0
  if (version == 'expertplus') {
    slide = 1
  }
  // const setupSlide = () => {

  //   ref?.current?.slickGoTo(slide)
  // }
  const settings = {
    dots: false,
    lazyLoad: true,
    slidesToShow: 1,
    autoplay: true,
    speed: 500,
    autoplaySpeed: 4000,
    cssEase: "linear",
    pauseOnHover: true,
    initialSlide: slide
  };
  const renderFallback = React.useCallback(() => {
    // return <></>
    if (version == 'expertplus') {
      return <div className="position-relative h-100 intro intro-expert-plus">
        {<IntroPlus />}
      </div>
    } else {
      return <div className="position-relative h-100 intro intro-expert">
        {<Intro />}
      </div>
    }
  }, [version])
  const component = React.useCallback(() => import("react-slick"), [])
  return (
    <section
      className="row position-relative intro-tab"
      style={{
        marginTop: 0,
        height: "640px",
        background: "transparent",
      }}
    >
      <ClientOnly
        refItem={ref}
        fallback={renderFallback}
        props={settings}
        component={component}
      >
        <div key="expert" className="position-relative h-100 intro intro-expert">
          {<Intro />}
        </div>
        <div key="expert-plus" className="position-relative h-100 intro intro-expert-plus">
          {<IntroPlus />}
        </div>
      </ClientOnly>
    </section >
  );
};


export const getVersion = () => {
  const location = useLocation()

  if (typeof window == 'undefined') {
    return 'expert'
  }
  const params = new URLSearchParams(location.search)
  let expertPlus = params.get('plus')
  if (!expertPlus) {
    return 'expert'
  }
  return expertPlus.trim().toLowerCase() == 'true' ? 'expertplus' : 'expert'
  // const params = new URLSearchParams(window.location.search)
  // let expertPlus = params.get('plus')
  // if (!expertPlus) {
  //   return 'expert'
  // }
  // return expertPlus.trim().toLowerCase() == 'true' ? 'expertplus' : 'expert'
}